module.exports = __webpack_public_path__ + "assets/8c9687dd57140c3de0cce4156ec8e490.png";